var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9167 66.6667C76.1214 66.6667 83.5833 59.2048 83.5833 50C83.5833 40.7953 76.1214 33.3333 66.9167 33.3333C57.7119 33.3333 50.25 40.7953 50.25 50C50.25 59.2048 57.7119 66.6667 66.9167 66.6667Z",
    fill: "#19BCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5833 100C42.7881 100 50.25 92.5381 50.25 83.3334C50.25 80.8206 50.25 75.2651 50.25 66.6667C42.7627 66.6667 37.2071 66.6667 33.5833 66.6667C24.3786 66.6667 16.9167 74.1286 16.9167 83.3334C16.9167 92.5381 24.3786 100 33.5833 100Z",
    fill: "#09CF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5833 66.6667C36.6516 66.6667 42.2071 66.6667 50.25 66.6667V33.3333C42.2071 33.3333 36.6516 33.3333 33.5833 33.3333C24.3786 33.3333 16.9167 40.7953 16.9167 50C16.9167 59.2048 24.3786 66.6667 33.5833 66.6667Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5833 33.3333C36.6516 33.3333 42.2071 33.3333 50.25 33.3333V0C42.2071 0 36.6516 0 33.5833 0C24.3786 0 16.9167 7.46192 16.9167 16.6667C16.9167 25.8714 24.3786 33.3333 33.5833 33.3333Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9167 33.3333H50.25V0H66.9167C76.1214 0 83.5833 7.46192 83.5833 16.6667C83.5833 25.8714 76.1214 33.3333 66.9167 33.3333Z",
    fill: "#FF7262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.ae98af0f95b1c62fac77bb7e98cb524f.svg";
export { ForwardRef as ReactComponent };